import { useTranslation } from "react-i18next";
import { Reports as ReportsFeature } from "@/partner/features/reports";
import { Meta } from "@/shared/components";

export function ReportsPage() {
  const { t } = useTranslation();
  return (
    <>
      <Meta title={t("reports.pageTitle")} pageType="Partner" />
      <ReportsFeature />
    </>
  );
}
